"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var getProp_1 = __importDefault(require("sportnet-utilities/lib/getProp"));
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var QueryHocTypes;
(function (QueryHocTypes) {
    QueryHocTypes["Array"] = "array";
    QueryHocTypes["Number"] = "number";
    QueryHocTypes["String"] = "string";
})(QueryHocTypes = exports.QueryHocTypes || (exports.QueryHocTypes = {}));
var getQueryString = function (props) {
    var location = getProp_1.default(props, ['history', 'location'], props.location);
    return getProp_1.default(location, ['search'], '');
};
exports.parseQueryString = function (queryString, config) {
    var partialQuery = queryString
        .replace(/^\?/, '')
        .split('&')
        .reduce(function (acc, part) {
        var split = part.split('=');
        var parameterName = decodeURIComponent(split[0]);
        var parameterValue = decodeURIComponent(split[1]);
        if (parameterName && parameterValue) {
            var type = getProp_1.default(config, ['parameters', parameterName, 'type'], '');
            switch (type) {
                case QueryHocTypes.Array:
                    var delimiter = getProp_1.default(config, ['parameters', parameterName, 'delimiter'], ',');
                    acc[parameterName] = parameterValue.split(delimiter);
                    break;
                case QueryHocTypes.Number:
                    acc[parameterName] = Number(parameterValue);
                    break;
                default:
                    acc[parameterName] = String(parameterValue);
                    break;
            }
        }
        return acc;
    }, {});
    // Add and replace falsy values in partialQuery with default values from config
    var parameters = getProp_1.default(config, ['parameters'], {});
    var query = Object.keys(parameters).reduce(function (acc, key) {
        if (!acc[key]) {
            var defaultValue = getProp_1.default(config, ['parameters', key], {}).defaultValue;
            if (defaultValue !== undefined) {
                acc[key] = defaultValue;
            }
        }
        return acc;
    }, __assign({}, partialQuery));
    return query;
};
exports.serializeQuery = function (query, config) {
    var search = Object.keys(query)
        .sort()
        .reduce(function (acc, parameterName) {
        var parameterValue = query[parameterName];
        if (parameterValue !== null && parameterValue !== undefined) {
            var type = getProp_1.default(config, ['parameters', parameterName, 'type'], '');
            if (type === QueryHocTypes.Array) {
                var delimiter = getProp_1.default(config, ['parameters', parameterName, 'delimiter'], ',');
                parameterValue = parameterValue.join(delimiter);
            }
            acc.push(encodeURIComponent(parameterName) + "=" + encodeURIComponent(String(parameterValue)));
        }
        return acc;
    }, []);
    return "?" + search.join('&');
};
var getDisplayName = function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
var create = function (WrappedComponent, config) {
    var QueryHoc = /** @class */ (function (_super) {
        __extends(QueryHoc, _super);
        function QueryHoc() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.setParameter = function (parameters) {
                var queryString = getQueryString(_this.props);
                var query = __assign({}, exports.parseQueryString(queryString, config), parameters);
                var serializedQuery = exports.serializeQuery(query, config);
                if (getProp_1.default(_this.props, ['history', 'push'], false)) {
                    _this.props.history.push(serializedQuery);
                }
                else if (_this.props.router) {
                    _this.props.router.push("" + _this.props.location.pathname + serializedQuery);
                }
            };
            return _this;
        }
        QueryHoc.prototype.render = function () {
            var queryString = getQueryString(this.props);
            var query = exports.parseQueryString(queryString, config);
            var serializedQuery = exports.serializeQuery(query, config);
            return (react_1.default.createElement(WrappedComponent, __assign({}, this.props, { serializedQuery: serializedQuery, query: query, setParameter: this.setParameter })));
        };
        return QueryHoc;
    }(react_1.default.PureComponent));
    hoist_non_react_statics_1.default(QueryHoc, WrappedComponent);
    // SSR support: extends props supplied to static method getInitialProps with queryProps
    if (typeof WrappedComponent['getInitialProps'] === 'function') {
        QueryHoc.getInitialProps = function (props) { return __awaiter(_this, void 0, void 0, function () {
            var queryString, query, serializedQuery;
            return __generator(this, function (_a) {
                queryString = getQueryString(props);
                query = exports.parseQueryString(queryString, config);
                serializedQuery = exports.serializeQuery(query, config);
                return [2 /*return*/, WrappedComponent.getInitialProps(__assign({}, props, { query: query,
                        serializedQuery: serializedQuery }))];
            });
        }); };
    }
    QueryHoc.displayName = "QueryHoc(" + getDisplayName(WrappedComponent) + ")";
    return QueryHoc;
};
function default_1(config) {
    return function (WrappedComponent) { return create(WrappedComponent, config); };
}
exports.default = default_1;
//# sourceMappingURL=index.js.map